const types = {

  SET_LISTA_ARQUIVOS_ASSINADOS: 'SET_LISTA_ARQUIVOS_ASSINADOS',
  SET_ARQUIVO_ASSINADO_BLOB_URL: 'SET_ARQUIVO_ASSINADO_BLOB_URL',
  SET_LISTA_TIPOS_ASSINATURA: 'SET_LISTA_TIPOS_ASSINATURA',

  SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG',
  HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types
